export const PATH_LOGIN = {
  LOGIN: '/',
  PASSWORD_RESET: '/password-forgot',
  PASSWORD_SENT: '/password-sent',
  PASSWORD_CREATE: '/password-reset',
  PASSWORD_WP_RESET: '/password-wp-reset'
}

export const PATH = {
  HOME: '/',
  TEAM: '/team',
  SUPPORT: '/support',
  SUPPORT_DETAILS: (id: string | number) => `/support/details/${id}`,
  SUPPORT_CREATE: '/support/create-ticket',
  ADS: '/ads',
  ACCOUNT: '/account',
  CONFIRM_EMAIL: (id: string | number) => `/confirm-change-email/${id}`,
  LOCAL_PRESENCE: '/local-presence'
}
